import { render } from "./NotesAndErrorsPanel.vue?vue&type=template&id=c882eeca"
import script from "./NotesAndErrorsPanel.vue?vue&type=script&lang=js"
export * from "./NotesAndErrorsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__